<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItemSelected" >Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="section">
      <div class="columns">
        <div class="column"></div>
        <div class="column is-two-thirds">
          <h2 class="mainTitle title is-2 center-title">Productos</h2>
        </div>
        <div class="column"></div>
      </div>
      <br/>
      <div class="columns">
        <div class="column"></div>
        <div class="column is-6">
          <div class="field has-addons">
            <p class="control is-expanded">
                <input v-model="nameSearch" :class="{'input': true, 'is-danger': errors.has('nameSearch') }" type="text" name="nameSearch" />
                <span v-show="errors.has('nameSearch')" class="help is-danger">{{ errors.first('nameSearch') }}</span>
            </p>
            <div class="control">
                <button class="button customButton" v-on:click="getProducts">Buscar</button>
                <button class="button customButton" v-on:click="cleanNameSearch" >Limpiar</button>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="columns">
        <div class="column">
          <aside class="menu customMenu" >
            <ul class="menu-list">
              <li v-for="productType of productTypeList"><a class="menuLink customMenuItem" v-on:click="searchType(productType)" >{{productType}}</a></li>
              <li><a class="menuLink customMenuItem" v-on:click="cleanTypeSearch">Todos</a></li>
            </ul>
          </aside>
        </div>
        <div class="column is-10">
          <div class="tile is-ancestor" v-for="line of productList">
            <div class="tile is-parent productTile" v-for="prodItem of line.products">
              <article class="tile is-child box productBox" >
                <img v-if="prodItem.firstImage != null" :src="multimediaBase+prodItem.firstImage"
                     :class="getProductImageClass(prodItem.direction)" align="left"/>
                <p class="title is-4" v-if="prodItem != null">{{prodItem.title}}</p>
                <p class="productInfo" v-if="prodItem != null">{{prodItem.message}}</p>
                <router-link v-if="prodItem != null" :to="{path: '/products/' + prodItem.id}" class="productLink">Más info</router-link>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img class="logoClass" src="/static/logo.png">
            <p class="footerInfo">
              Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la
              tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de
              asesoría técnica profesional, capacitación y productos efectivos a precios justos.
            </p>
          </div>
          <div class="column is-4">
            <a href="https://www.google.com/maps/@14.5945742,-90.5766572,17.25z" >
              <img width="400px" height="300px" class="mapInfo" src="/static/images/newmap.png"/>
            </a>
          </div>
          <div class="column">
            <p class="footerContact">
              2da calle 18-87 sector B-1<br/>
              Ciudad San Cristóbal zona 8 de Mixco<br/>
              Guatemala<br/>
              (502) 2478-1179 / 80 / 82 / 99<br/><br/>
              <a href="https://wa.me/50240251346">
                <img width="20px" height="20px" src="/static/images/whatsapp-icon.png" class="iconImage">
                WhatsApp: (502) 4025 - 1346
              </a><br/><br/>
              <a href="mailto:ventas@hipromeasa.com">
                <img width="20px" height="20px" src="/static/images/mail-icon.png" class="iconImage">
                E-Mail: ventas@hipromeasa.com
              </a><br/><br/>
              <a href="https://www.facebook.com/hipromeasa">
                <img width="20px" height="20px" src="/static/images/facebook-icon.png" class="iconImage">
                Estamos en Facebook
              </a>
            </p>
          </div>
        </div>
        <div class="content has-text-centered">
          <p class="footerLast">2025 - Todos los derechos reservados</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
import { baseurl } from '@/api/ApiConst.js'
export default {
  name: 'landing',
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      productTypeList: [],
      productList: [],
      nameSearch: '',
      typeSearch: '',
      multimediaBase: baseurl + '/multimedia/'
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    getProducts () {
      ApiClient.products(this.nameSearch, this.typeSearch).then(response => {
        if (response.data.success) {
          this.productList = response.data.productLine
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    getTypes () {
      ApiClient.productTypes().then(response => {
        if (response.data.success) {
          this.productTypeList = response.data.productTypes
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    cleanNameSearch () {
      this.nameSearch = null
      this.getProducts()
    },
    cleanTypeSearch () {
      this.typeSearch = null
      this.getProducts()
    },
    getData () {
      this.getProducts()
      this.getTypes()
    },
    searchType (selectedType) {
      this.typeSearch = selectedType
      this.getProducts()
    },
    getProductImageClass (direction) {
      return direction ? 'productImageH' : 'productImageV'
    }
  },
  created () {
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 60px;
    width: 220px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .menuLink {
    text-align: left;
  }
  .mainTitle {
    text-align: center !important;
  }
  .title {
    word-break: normal;
    overflow-wrap: break-word;
    text-align: right;
  }
  .productTile {
     min-height: auto !important;
  }
  .productBox {
     max-height: 350px;
     overflow-y: auto;
  }
  .productInfo {
    font-size: small;
    text-align: center;
  }
  .productLink {
    font-size: small;
    float:right;
  }
  .productImageH {
    align-content: center;
    height: 40%;
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }
  .productImageV {
    margin-left: 1%;
    margin-right: 5%;
    align-content: initial;
    height:auto;
    width:30%;
    max-height: 100%;
  }
  .footerInfo {
    margin-left: 60px;
    margin-right:60px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:80px;
    margin-top: 30px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
    margin-top: -10px;
  }
  .mapInfo {
    padding-top: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .iconImage {
    vertical-align: middle;
    padding-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// ProductsComponent.vue?65cb03f5